export default {
  JSON: 'application/json',
  FORM_URLENCODED: 'application/x-www-form-urlencoded'
}
